export const template0: SimpleProjectServiceAPI.ConfigurationDataDto = {
  root: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
  storeId: '601a75c3abc3a6544a187365',
  articles: [
    {
      id: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      number: '920012 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '9108fd47-eec3-488c-988d-7048bbfd4ce3',
      number: '927300 300/3',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '19bd8795-a51c-4197-aec2-2c5500816722',
      number: '927341 2',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
        {
          ralValue: 'RAL 7016',
          affectedMaterial: 'config_ral_secondary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      number: '928010 1362',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      number: '928056 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '49cc5cdf-82e6-4d10-9a28-219055be540b',
      number: '928600 1500',
      colors: [],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'b2cb896c-d4d7-44d8-8140-abd0b0d450ab',
      number: '928070 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'd9af3dc8-f142-4ff4-bd1a-0a4b3c4c2f7f',
      number: '928070 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      number: '928270 2',
      colors: [],
      requiredLightingArticlesIds: [],
    },
    {
      id: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      number: '928444 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'f1bb0add-2177-4188-9980-c6e6eeee12b2',
      number: '928131 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      number: '928230 1500/AB1',
      colors: [],
      requiredLightingArticlesIds: [],
    },
    {
      id: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      number: '928211 1500',
      colors: [
        {
          ralValue: 'RAL 7035',
          affectedMaterial: 'config_ral_primary',
        },
      ],
      requiredLightingArticlesIds: [],
    },
  ],
  slots: [
    {
      id: '22974684-d897-4aa6-a74b-5d1ec2b49c14',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      name: 'rightColumnSuspension',
      xIndex: 9,
      alignment: null,
    },
    {
      id: '9097fc5c-181e-443f-8852-7928e35738a2',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'leftColumnSuspension',
      xIndex: 22,
      alignment: null,
    },
    {
      id: '7acfba29-c0dc-4881-873a-dcb78db91b80',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'columnThreadedBushTop',
      xIndex: 2,
      alignment: 'left',
    },
    {
      id: '9161a8bf-8ceb-4813-a1c3-46992a32ca75',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 8,
      alignment: null,
    },
    {
      id: '6999c0b1-0dfe-46e0-ae10-d337c01a0cb8',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 24,
      alignment: null,
    },
    {
      id: 'ae4df682-5d38-4a51-b266-5d4987e5455b',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: '6d1197bc-9fcf-404e-9420-20b5147e55f9',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '484842f0-851b-4620-b9c4-620dcc7de0cd',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: 'b6caaa23-d502-4215-bbbe-cce3443e1859',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: 'bf74c992-6972-4976-9cb7-cf7bf6495433',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      name: 'rightColumnSuspension',
      xIndex: 10,
      alignment: null,
    },
    {
      id: '7f33096a-342a-498a-9a9a-866e8042c2de',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 11,
      alignment: null,
    },
    {
      id: 'c2c5ea00-1eac-4647-b591-9877aa97d8a8',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnMediaModule',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: 'f41d078d-8ae9-4ef6-bf46-54d06dc20b60',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'f1bb0add-2177-4188-9980-c6e6eeee12b2',
      name: 'rightColumnSuspension',
      xIndex: 13,
      alignment: null,
    },
    {
      id: 'ccf8d434-4c25-4970-b30b-4f353049ff2b',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 11,
      alignment: null,
    },
    {
      id: '90d01442-dc17-4900-af66-e63ea3b08948',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushBottom',
      xIndex: 2,
      alignment: 'left',
    },
    {
      id: '7cc1d198-76b4-4298-b78f-c7798d392012',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'columnThreadedBushTop',
      xIndex: 2,
      alignment: 'right',
    },
    {
      id: '7b6b41b6-9d4c-4644-aa92-90034daaa501',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnMediaModule',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: '302b8174-0d76-4476-9b66-387b84cee57a',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 25,
      alignment: null,
    },
    {
      id: 'feb7412a-3d23-4f1e-8afd-c8c7270fa10d',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: 'f2d680f0-4ae4-4fb0-99a1-c250eba920b0',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: '41c4bfc5-55a4-4e75-8571-ec501a4e37a3',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: '26310576-2818-4415-955f-9431ad75527c',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      childId: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      xIndex: 23,
      alignment: null,
    },
    {
      id: '335757e7-2091-4c45-a9ab-54bbc825fa2b',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'rightColumnSuspension',
      xIndex: 22,
      alignment: null,
    },
    {
      id: 'f5712e3b-c09e-4d87-852b-42b65d05bb25',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'rightColumnSuspension',
      xIndex: 23,
      alignment: null,
    },
    {
      id: '334bb29d-4d37-4c5d-9482-a2ff6d586893',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnMediaModule',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '61f3ab99-27e5-4259-9c11-21693a0bb619',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      childId: 'f1bb0add-2177-4188-9980-c6e6eeee12b2',
      xIndex: 14,
      alignment: null,
    },
    {
      id: '983a770e-1995-4479-8f49-31c514db43bb',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'columnThreadedBushTop',
      xIndex: 3,
      alignment: 'left',
    },
    {
      id: 'ec31e21c-edce-405c-9a50-fd0d2fa488a3',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      childId: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      xIndex: 10,
      alignment: null,
    },
    {
      id: 'c68768bb-b686-4dae-8e20-caba05a08707',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 25,
      alignment: null,
    },
    {
      id: '3b82632d-8f20-440d-8e41-b1664c30d8a6',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushBottom',
      xIndex: 3,
      alignment: 'left',
    },
    {
      id: '05a8b4b5-67b2-4f84-acf0-000251680456',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'fd33a4b8-2fc6-49e1-91da-24e38fe23dba',
      name: 'columnThreadedBushTop',
      xIndex: 3,
      alignment: 'right',
    },
    {
      id: 'cc8fd7b2-dffd-4354-aabb-447268064c9a',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 12,
      alignment: null,
    },
    {
      id: '9f99f4a0-0d94-4c37-8ecd-c8232ce58996',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      name: 'leftColumnSuspension',
      xIndex: 9,
      alignment: null,
    },
    {
      id: '5ecf3c43-c29a-479c-a3e0-829be1ae75bb',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 21,
      alignment: null,
    },
    {
      id: 'c3d1eefa-b90d-48d6-b738-6bf1ab064732',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 21,
      alignment: null,
    },
    {
      id: '3a4875b9-4e9f-4962-b74d-1b04a91fd190',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 24,
      alignment: null,
    },
    {
      id: '5eebcc6e-4319-41a1-8e3f-ca502f8c88a8',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 12,
      alignment: null,
    },
    {
      id: '227b8f32-0595-49ac-8e8d-243d6fb8bc30',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rearPanelSmall',
      alignment: null,
    },
    {
      id: 'adb65df2-a6a0-4211-96d6-5916942cafcc',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'f1bb0add-2177-4188-9980-c6e6eeee12b2',
      name: 'rightColumnSuspension',
      xIndex: 14,
      alignment: null,
    },
    {
      id: '17737d76-7dfc-4a39-9cd7-2d04e0b475b6',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'f1bb0add-2177-4188-9980-c6e6eeee12b2',
      name: 'leftColumnSuspension',
      xIndex: 13,
      alignment: null,
    },
    {
      id: 'a67b88b2-79e2-4a49-9617-c4905f5486c9',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnTop',
      childId: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      alignment: null,
    },
    {
      id: 'a73b5be3-f47b-4460-b664-833147c0463a',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rearPanel',
      childId: 'b2cb896c-d4d7-44d8-8140-abd0b0d450ab',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '28655d55-e269-44dc-9899-f8b8b5df60d2',
      type: 'PAIR',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: 'b2cb896c-d4d7-44d8-8140-abd0b0d450ab',
      name: 'kanbanBase',
    },
    {
      id: 'f53320d5-ee92-476a-b023-422cdc835413',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rearPanel',
      childId: 'd9af3dc8-f142-4ff4-bd1a-0a4b3c4c2f7f',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '9c54ce17-a81e-4ed6-8e88-63dec950cd8a',
      type: 'SINGLE',
      parentId: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      name: 'supportArmBracket',
      xIndex: 2,
      alignment: null,
    },
    {
      id: '9fa5ae55-894d-46f8-b0b9-f7f98713216d',
      type: 'SINGLE',
      parentId: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      name: 'supportArmBracket',
      childId: '49cc5cdf-82e6-4d10-9a28-219055be540b',
      xIndex: 3,
      alignment: null,
    },
    {
      id: 'fcb90e1b-157b-4420-a8e5-4eab9f292a83',
      type: 'SINGLE',
      parentId: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      name: 'supportArmBracket',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '31f5b10f-0641-4a4c-a451-b8a497995b06',
      type: 'SINGLE',
      parentId: '6df25552-c54b-4585-b225-4a2dccddd9f6',
      name: 'supportArmBracket',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '89ce8de8-836c-4843-9499-17db248f0d7b',
      type: 'PAIR',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'supportColumnBase',
      childId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
    },
    {
      id: '20e91f42-0348-4654-a056-2249ddc0f78c',
      type: 'SINGLE',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'tableSidePlate',
      alignment: 'left',
    },
    {
      id: '69429b6e-dc74-429f-8236-d02c08fa1fe3',
      type: 'SINGLE',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'structureDividerBase',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '273a1bfd-bdae-4e41-861a-d7ca7e5cfc96',
      type: 'SINGLE',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'structureDividerBase',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '9a2bdbeb-a77d-425f-99af-c29b3a346b8b',
      type: 'PAIR',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'supportColumnBaseCenter',
    },
    {
      id: '485aeedd-6e89-49db-923c-ac920620933a',
      type: 'SINGLE',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'tableSidePlate',
      alignment: 'right',
    },
    {
      id: '57498a29-1533-4e68-9032-d3c635042ea3',
      type: 'LINE',
      parentId: 'b6f82e08-b9fe-4b2f-b7c4-5ef9519866d9',
      name: 'tabletopSubstructure',
      children: [
        {
          id: '33ad7830-9c0e-454a-9a88-0e42a65cafe8',
          position: 0,
        },
        {
          id: '19bd8795-a51c-4197-aec2-2c5500816722',
          position: 17,
        },
        {
          id: '9108fd47-eec3-488c-988d-7048bbfd4ce3',
          position: 98,
        },
      ],
      axis: 'X',
      length: 1380,
    },
    {
      id: '5ef2d743-2e0c-422e-9904-a7fce05273eb',
      type: 'SINGLE',
      parentId: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'multiMediaSwivelArm',
      alignment: null,
    },
    {
      id: 'c958836f-ab5a-4056-9312-be269f4a6404',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      childId: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      xIndex: 2,
      alignment: null,
    },
    {
      id: 'e0f2ddac-9b88-45c1-834d-bf4557deb105',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'leftColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: '7a424ad4-05cf-4091-91e3-fc094daaef6a',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'leftColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: '5bbc1136-3747-465e-a69d-9538e5f4c22d',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'rightColumnSuspension',
      xIndex: 0,
      alignment: null,
    },
    {
      id: 'd042249b-3a2c-4a25-ba64-189aa3dc8cc9',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '041e4f91-69a0-4710-8adb-f32de9ad116d',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushBottom',
      childId: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      xIndex: 3,
      alignment: 'right',
    },
    {
      id: 'c1951f33-2833-4322-969b-d772791992b2',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'columnThreadedBushBottom',
      xIndex: 2,
      alignment: 'right',
    },
    {
      id: 'd1669db8-361e-4177-a6d9-abaed3db5342',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 3,
      alignment: null,
    },
    {
      id: 'e12f5b52-3846-4f3f-a5c3-a2b214ae9f88',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 7,
      alignment: null,
    },
    {
      id: 'b4993457-f4d7-4fb3-be94-7aa3e9971d0c',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 8,
      alignment: null,
    },
    {
      id: 'eb895ee3-a0b8-44d2-b134-22f2a3340560',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 5,
      alignment: null,
    },
    {
      id: '36320776-cb3f-4daa-bcf5-ee4dbb265476',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 4,
      alignment: null,
    },
    {
      id: '8801841d-67ed-407d-9c71-402c6d8a7d57',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'rightColumnSuspension',
      xIndex: 6,
      alignment: null,
    },
    {
      id: 'c905184b-4949-4120-88b0-cd2a3a4d70e3',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '5a1c4bf6-7187-4872-96d2-bd045c8ba8bb',
      name: 'columnThreadedBushBottom',
      xIndex: 1,
      alignment: 'right',
    },
    {
      id: '056896ab-63d3-4ef1-aa29-54b36fc054d0',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'rightColumnSuspension',
      xIndex: 1,
      alignment: null,
    },
    {
      id: 'e7a3fd06-2446-4dd8-be21-20d72920f2ba',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'rightColumnSuspension',
      xIndex: 2,
      alignment: null,
    },
    {
      id: 'e4546c66-9bac-4536-9e1e-d461a86fb408',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      blockedBy: '4749b67f-bbd1-4fe0-8182-c6d7e13258b4',
      name: 'columnThreadedBushBottom',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '30b44613-b3d5-4ac8-a882-3fa5d804c000',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 18,
      alignment: null,
    },
    {
      id: '5c2266ce-9d50-40bf-8643-79dcf63612c7',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 18,
      alignment: null,
    },
    {
      id: '158a1463-f2f5-483a-b7af-1ab5ad16b2a5',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 17,
      alignment: null,
    },
    {
      id: '4fd60688-0712-4935-9911-149594d0649e',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushTop',
      xIndex: 0,
      alignment: 'left',
    },
    {
      id: '5cf43b1f-c49a-4383-92f7-489258133c0e',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 17,
      alignment: null,
    },
    {
      id: '67b6811a-7713-4a3d-9131-985e5c857e22',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushTop',
      xIndex: 0,
      alignment: 'right',
    },
    {
      id: '3f82f18f-fc40-4d30-b684-c2a68ec114a8',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 16,
      alignment: null,
    },
    {
      id: 'bb217847-4d39-4616-894b-e8311dc56331',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 15,
      alignment: null,
    },
    {
      id: 'd9b1cd9d-a04b-46b9-bb3d-cdff5910cdb1',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 15,
      alignment: null,
    },
    {
      id: '56bd542f-66c9-46e1-851f-ed40532dde7d',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 16,
      alignment: null,
    },
    {
      id: '48cdfb9b-7ed9-42b1-812d-b63fb73b23bf',
      type: 'LINE',
      parentId: 'bd8fcc56-c9eb-45a3-a6f8-ee5b02b5eb92',
      name: 'multifixBottom',
      children: [],
      axis: 'X',
      length: 1434,
    },
    {
      id: '034704f6-18b1-4117-90b2-33fc1a5c2ad0',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 20,
      alignment: null,
    },
    {
      id: 'd7ebac8b-3dda-4ac9-9781-8d044a766b63',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 19,
      alignment: null,
    },
    {
      id: 'b6d8fe1c-991b-4651-8066-1277dd8222e8',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushTop',
      xIndex: 1,
      alignment: 'left',
    },
    {
      id: '2333fd79-ec63-403b-9f36-61e3471f1811',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'leftColumnSuspension',
      xIndex: 19,
      alignment: null,
    },
    {
      id: '5d6001b2-1108-408b-93a7-750948d11e89',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'rightColumnSuspension',
      xIndex: 20,
      alignment: null,
    },
    {
      id: '3841529d-1437-4138-b8a8-69b4d29f62ed',
      type: 'SINGLE',
      parentId: 'ea6f8e6c-4b4c-458a-a93e-fb5c839e9693',
      name: 'columnThreadedBushTop',
      xIndex: 1,
      alignment: 'right',
    },
  ],
  requiredConnectArticles: [],
  requiredLightingArticles: [],
  rootArticleName: 'eLevel workstation 1500mm',
  socketType: 'F',
  theme: {
    primaryColor: 'RAL 7035',
    secondaryColor: 'RAL 7016',
  },
  version: 5,
};
